var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGettingStarted = function SvgIconGettingStarted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon_getting started"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5047ff",
    d: "M8.118 17.035 6.91 15.793a1.23 1.23 0 0 1-.336-1.223c.117-.348.273-.8.5-1.32H2.938a.936.936 0 0 1-.807-1.414l2.05-3.457A2.84 2.84 0 0 1 6.6 6.965h3.213c.094-.121.188-.266.281-.406A10.285 10.285 0 0 1 20.9 2.206a1.1 1.1 0 0 1 .891.89 10.28 10.28 0 0 1-4.352 10.811 4 4 0 0 1-.441.246V17.4a2.81 2.81 0 0 1-1.379 2.422l-3.457 2.047a.933.933 0 0 1-1.414-.8v-4.194c-.551.188-1.031.348-1.395.465a1.22 1.22 0 0 1-1.238-.3ZM17 8.527a1.54 1.54 0 0 0 1.563-1.563 1.563 1.563 0 1 0-3.125 0A1.54 1.54 0 0 0 17 8.527",
    "data-name": "Group 1787"
  }))));
};
export default SvgIconGettingStarted;